<template>
    <div class="newLogin">
        <p class="closeLogin" @click="close">×</p>
        <div class="fr-ac-jsb mb-20">
            <div class="fs-23 bold">注册/登录</div>
            <img src="@/assets/images/newlogoh.png" alt=""/>
        </div>
        <div class="fr-ac pt-10">
            <div v-for="item in accountList" :key="item.id" class="mr-30 pb-6 fr-ac" :class="item.id==accountIndex?'accountActive':''" @click="account(item)">
                <img :src="`https://file.gkzzd.cn${item.icon}`" style="width: 20px;height: 20px;color: #0077d5;"/>
                <div class="ml-5">{{ item.title }}</div>
            </div>
        </div>
        <div v-show="accountIndex==1">
            <el-input
                class="input-box"
                v-model="phone"
                maxlength="11"
                placeholder="请输入手机号"
            ></el-input>
            <el-input
                class="input-box"
                v-model="code"
                maxlength="6"
                placeholder="请输入验证码"
            >
                <div
                    slot="suffix"
                    @click="getCode()"
                    class="mt-10 mr-5"
                    style="color: #737b81"
                >
                    {{ code_text }}
                </div>
            </el-input>
            <el-button type="primary" class="login-btn" @click="toLogin()">登录</el-button>
        </div>
        <div v-show="accountIndex==2" id="weixin"></div>
        <!-- <el-input
            class="input-box"
            v-model="phone"
            maxlength="11"
            placeholder="请输入手机号"
            v-show="!isWeixin"
        ></el-input>
        <el-input
            class="input-box"
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
            v-show="!isWeixin"
        >
            <div
                slot="suffix"
                @click="getCode()"
                class="mt-10 mr-5"
                style="color: #737b81"
            >
                {{ code_text }}
            </div>
        </el-input>
        <el-button type="primary" class="login-btn" v-show="!isWeixin" @click="toLogin()"
            >登录</el-button
        >
        <div class="t-c pt-10" @click="weixin" id="weixin">
            <img src="https://file.gkzzd.cn/www/gkzzd/uploads/20250220/1d0b4e762b4ba3e2561aa7171ef297a6.png" style="width: 30px;height: 30px;"/>
        </div> -->
        <div class="fr mt-20">
            <div class="select-btn" @click="selectAgreement()">
                <i
                    v-if="isAgree"
                    class="el-icon-check"
                    style="color: #666666"
                ></i>
            </div>
            <div class="select-text">
                我已阅读并同意<span class="high-light" @click="checkContent(1)"
                    >《用户协议》</span
                ><span class="high-light" @click="checkContent(2)"
                    >《隐私政策》</span
                >，未注册的手机号验证后将自动创建新账号
            </div>
        </div>
        <div class="province_pop_up fr-ac-jc" v-if="is_show">
            <div class="loginAgreement fc-ac-jc">
                <p class="pt-20 pb-30 fs-18">
                    高考早知道小程序/pc版{{ popup_title }}
                </p>
                <agreement :type="type"></agreement>
                <div class="pt-20 pb-10">
                    <el-button
                        style="width: 112px"
                        type="primary"
                        :disabled="time > 0 ? true : false"
                        @click="agree"
                        >同意<span v-show="time > 0"
                            >({{ time }}s)</span
                        ></el-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import agreement from "@/components/agreement.vue";
import store from "@/store/index";
export default {
    components: {
        agreement,
    },
    data() {
        return {
            phone: "",
            code: "",
            count: 60,
            code_text: "获取验证码",
            type: 1, //1用户协议 2隐私协议
            isAgree: false,
            isClick: true,
            popup_title: "",
            is_show: false, //协议弹窗
            intervalId: "", //定时器
            time: 5, //倒计时时间
            isWeixin: false,
            accountList: [
                {
                    id: 1,
                    title: '验证码登录',
                    icon:'/www/gkzzd/uploads/20250320/8229d822396659e4d065864b276fb508.png'
                },
                {
                    id: 2,
                    title: '微信登录',
                    icon:'/www/gkzzd/uploads/20250220/1d0b4e762b4ba3e2561aa7171ef297a6.png'
                },
            ],
            accountIndex:1
        };
    },
    methods: {
        account(val) {
            if (val.id == 2) {
                if (!this.isAgree) {
                    return this.$message.warning("请阅读并勾选用户协议及隐私政策");
                } else {
                    this.accountIndex = val.id
                }
            } else {
                this.accountIndex = val.id
            }
            if (!this.isWeixin) {
                this.weixin()
            }
        },
        close() {
            this.$emit("close");
        },
        //获取验证码
        async getCode() {
            if (!this.phone) {
                this.$message.warning("请输入手机号码");
                return;
            }
            var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (!phonereg.test(this.phone)) {
                this.$message.warning("请输入正确的手机号码");
                return;
            }

            //计算倒计时
            if (this.isClick) {
                console.log(123, "123");
                this.isClick = false;
                var index = setInterval(() => {
                    this.count--;
                    console.log(this.count);
                    this.code_text = this.count + "s";
                    if (this.count == 0) {
                        this.code_text = "重新获取";
                        clearInterval(index);
                        this.isClick = true;
                        this.count = 60;
                    }
                    console.log(this.code_text);
                }, 1000);

                const res = await this.$http.fetch("/api/login/sendSms", {
                    phone: this.phone,
                    type: 1,
                });
                let data = res.data;
                if (data.status && data.status !== 200) {
                    console.log(data.message);
                    return Promise.reject(data);
                }
            }
        },
        //勾选协议
        selectAgreement() {
            if (this.accountIndex == 2) {
                return
            }
            this.isAgree = !this.isAgree;
        },
        //登录
        toLogin() {
            if (!this.phone) {
                this.$message.warning("请输入手机号码");
                return;
            }
            if (!this.code) {
                this.$message.warning("请输入验证码");
                return;
            }
            if (!this.isAgree) {
                this.$message.warning("请阅读并勾选用户协议及隐私政策");
                return;
            }
            var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (!phonereg.test(this.phone)) {
                this.$message.warning("请输入正确的手机号码");
                return;
            }
            let params = {
                phone: this.phone,
                code: this.code,
            };
            this.sendLogin(params);
        },
        async sendLogin(params) {
            this.$http.fetch("/api/login/login", params).then((res) => {
                if (res.status === 200) {
                    console.log(res.data.token);
                    this.$store.dispatch("user/setToken", res.data.token);
                    //   location.reload()
                    this.$emit("login");
                    this.$router.push('/')
                } else {
                    this.$message.warning(res.msg);
                }
            });
        },
        //查看用户协议和隐私政策
        checkContent(type) {
            this.type = type;
            this.popup_title = type == 1 ? "用户协议" : "隐私政策";
            this.is_show = true;
            this.time = 5;
            this.intervalId = setInterval(() => {
                console.log(this.time, "this.time");
                if (this.time > 0) {
                    this.time -= 1;
                }
            }, 1000);
        },
        //同意
        agree() {
            this.is_show = false;
            clearInterval(this.intervalId);
        },
        weixin() {
            new window.WxLogin({
                id: "weixin",
                appid: "wx86b25b7f32d3d649",
                scope: "snsapi_login",
                redirect_uri: encodeURIComponent(
                    "https://www.gkzzd.cn/school/weixin"
                ),
                state: "",
                style: "black",
                href: "https://gw.gkzzd.cn/static/weixin.css",
                self_redirect: true,
                fast_login: 1,
            });
            this.isWeixin = true;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.newLogin {
    width: 450px;
    background: #fff;
    border-radius: 5px;
    padding: 35px 40px;
    position: relative;
    .closeLogin {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 24px;
        cursor: pointer;
        color: #666666;
    }

    .input-box {
        margin-top: 15px;
    }
    .login-btn {
        margin-top: 20px;
        width: 100%;
        height: 54px;
        font-size: 19px;
        font-weight: 600;
        background-color: #0077d5;
        border-color: #0077d5;
    }
    .select-btn {
        width: 18px;
        height: 18px;
        border: 1px solid #666666;
        border-radius: 4px;
        display: flex;
        flex-shrink: 0;
        margin: 2px 5px 0 0;
        cursor: pointer;
    }

    .select-text {
        color: #666666;
        font-size: 15px;
    }

    .high-light {
        color: #0077d5;
        cursor: pointer;
    }
    .loginAgreement {
        width: 70%;
        background: #fff;
        padding: 10px 25px;
    }
    .accountActive{
        color: #0077d5;
        border-bottom: 2px solid #0077d5;
    }
    iframe{
        width: 100%;
    }
     
}
</style>